"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Section_v2", {
  enumerable: true,
  get: function get() {
    return _Section_v.default;
  }
});

var _Section_v = _interopRequireDefault(require("./Section_v2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }